import {AfterViewInit, Component} from '@angular/core';
import {StoreService} from '../../../services/store.service';
import {AuthService} from '../../../services/auth.service';
import {ScCargoOverview} from '../../../forms/sc-cargo-overview';
import {ScOreOverview} from '../../../forms/sc-ore-overview';
import {ScRawMaterialOverview} from '../../../forms/sc-raw-material-overview';

@Component({
  selector: 'app-bot-resources',
  templateUrl: './bot-resources.component.html',
  styleUrls: ['./bot-resources.component.css']
})
export class BotResourcesComponent implements AfterViewInit {

  public loading_text = '';
  public is_loading = true;
  public fields: any[];
  public mode = 'edit';
  public edit = false;
  public rows = [];
  public count = 0;

  public record: any;
  public cargoRows: any[];
  public oreRows: any[];
  public activeVersion: string;
  public activeVersionId: number;
  public ScCargoOverview: ScCargoOverview;
  public ScOreOverview: ScOreOverview;
  public ScRawMaterialOverview: ScRawMaterialOverview;


  constructor(private storeService: StoreService,
              private authService: AuthService) {
  }

  ngAfterViewInit(): void {
    this.loadStores();
  }

  private loadStores() {
    const oreStore = this.storeService.createNoneGlobalStore('ore',
        'games/starcitizen/possible-commodities/ore', 'com_id');
    const rawMaterialStore = this.storeService.createNoneGlobalStore('raw',
        'games/starcitizen/possible-commodities/raw', 'com_id');
    const cargoStore = this.storeService.createNoneGlobalStore('cargo',
        'games/starcitizen/possible-commodities/cargo', 'com_id');

    const activeVersionStore = this.storeService.createNoneGlobalStore('version',
        'games/starcitizen/active-version', 'com_id');

    const stores = [];
    // if (!this.stores['sc_events'].isLoaded()) {
    stores.push(oreStore.loadStore());
    stores.push(rawMaterialStore.loadStore());
    stores.push(cargoStore.loadStore());
    stores.push(activeVersionStore.loadStore());

    Promise.all(stores).then((result) => {

      const cargoRecords = cargoStore.getRecords();
      for (let i = 0; i < cargoRecords.length; i++) {
        const rec = cargoRecords[i];
        rec.data.price = Number(rec.data.price);
      }
      this.cargoRows = cargoRecords;

      const oreRecords = oreStore.getRecords();
      for (let i = 0; i < oreRecords.length; i++) {
        const rec = oreRecords[i];
        rec.data.price = Number(rec.data.price);
      }
      this.oreRows = oreRecords;
      this.activeVersion = activeVersionStore.getRecords()[0].data.version_name;
      this.activeVersionId = activeVersionStore.getRecords()[0].data.version_id;
      this.ScRawMaterialOverview = new ScRawMaterialOverview(this.storeService, this.authService, 'edit');
      this.ScCargoOverview = new ScCargoOverview(this.storeService, this.authService, 'edit');
      this.ScOreOverview = new ScOreOverview(this.storeService, this.authService, 'edit');
      this.is_loading = false;
    });
  }

  public scrollTo(target: string) {
    document.getElementById(target).scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest'
    });
  }
}
